module.exports = __webpack_public_path__ + "img/icon2.68f45a01.png";